import LeaderboardCutLine from './leaderboard-cut-line'

export default LeaderboardCutLine
